module.exports = __webpack_public_path__ + "static/Rectangle217-51ef4f5445331addf8d109a5f8a8e929.png";